module.exports = __webpack_public_path__ + "img/MeetingsCorporateTheatre.6067752c.jpg";